import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IIcd10CodesModel } from './types';

const icd10Codes: IIcd10CodesModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default icd10Codes;
